import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CONTACT } from "@/lib/catalog";
import { Eyebrow, Reveal } from "./Reveal";

const QA = [
  ["Are the coloured balls the same as the white ones?", "Every POW ball is made exactly the same way. The Splatter and Fluorescent balls are simply our white match balls with a splash of colour — nothing else is different."],
  ["How do I pay?", "Add your balls to the cart and place your order. You'll get an order reference and our bank details straight away. Pay by bank transfer using your reference, and we'll post your balls once the payment arrives."],
  ["How is postage worked out?", "Postage is a flat rate based on how many balls you order and which Australian state or territory you're in. You'll see the exact amount in your cart before you place the order."],
  ["Can I mix colours in one order?", "Yes. Add any mix of Game, Splatter and Fluorescent balls — postage is calculated on the total number of balls."],
  ["Can clubs order in bulk?", `Absolutely. Add as many as you need, or get in touch at ${CONTACT.email} and we'll help with larger club orders.`],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-[#F5F0E8] px-5 py-24 sm:px-8 lg:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Good to know</Eyebrow>
        <h2 className="font-display text-6xl font-black uppercase leading-[0.88] tracking-tight text-[#112E23] sm:text-7xl">
          Questions, <span className="font-serif-i normal-case font-normal text-[#6E472B]">answered.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7 lg:col-start-6">
        <Accordion type="single" collapsible defaultValue="q0">
          {QA.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-[#112E23]/15">
              <AccordionTrigger data-testid={`faq-item-${i}`} className="py-6 text-left font-display text-2xl font-bold uppercase text-[#112E23] hover:no-underline sm:text-3xl">
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#112E23]/80">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
